(function () {
    'use strict';

    angular.module('blocks.backendHubProxy', []);
})();
